
function isoToDate( time ) {
    const date = new Date( time );
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return date.toLocaleDateString( 'en-US', options );
}

/**
 * ISO Date format
 * 
 * @param {string} time e.g  2023-05-10T14:43:47Z
 * @returns {string} e.g.  09:11 May 11, 2023
 */
function isoToDay( time ) {
    const date       = new Date( time );
    const options    = { hour12: false };
    const timeString = date.toLocaleTimeString( 'en-US', options ).replace( /:\d+$/, '' );
    const month      = new Intl.DateTimeFormat( 'en-US', { month: 'short' }).format( date );
    const day        = date.getUTCDate();
    const year       = date.getUTCFullYear();
    return `${timeString} ${month} ${day}, ${year}`;
}

/**
 * ISO Date format
 * 
 * @param {string} time e.g  2023-05-10T14:43:47Z
 * @returns {string} e.g.  09:11
 */
function isoToTime( time ) {
    const date       = new Date( time );
    const options    = { hour12: false };
    return date.toLocaleTimeString( 'en-US', options ).replace( /:\d+$/, '' );
}

/**
 * is Same day
 * 
 * @param {string} time e.g  2023-05-11T01:11:51Z
 * @param {string} time e.g  2023-05-10T14:43:47Z
 * @returns {boolean}
 */
function isSameDay( day1, day2 ) {
    day1 = day1.match( /^\d+-\d+-\d+/i )[0];
    day2 = day2.match( /^\d+-\d+-\d+/i )[0];
    return day1 == day2;
}

/**
 * is Today
 * 
 * @param {string} iso time 
 * @returns {boolean} 
 */
function isToday( time ) {
    const date = new Date( time );
    const today = new Date();
    return date.getUTCFullYear() === today.getUTCFullYear() &&
           date.getUTCMonth()    === today.getUTCMonth() &&
           date.getUTCDate()     === today.getUTCDate();
}

/**
 * is Yestoday
 * 
 * @param {string} iso time 
 * @returns {boolean} 
 */
function isYestoday( time ) {
    const now   = new Date(),
          year  = now.getFullYear(),
          month = now.getMonth() + 1,
          day   = now.getDate(),
          oneday= 24 * 60 * 60 * 1000,
          today = +new Date( `${year}-${month}-${day} 00:00:00` ),
          yestoday = +new Date( `${year}-${month}-${day} 23:59:59` ) - oneday,
          date  = +new Date( time );
    return date + oneday > yestoday && date < today;
}

function isMorning( time ) {
    const hour = new Date( time ).getHours();
    return hour >= 6 && hour <= 11;
}

function isNoon( time ) {
    const hour = new Date( time ).getHours();
    return hour > 11 && hour < 13;
}

function isNight( time ) {
    const hour = new Date( time ).getHours();
    return hour >= 21 && hour <= 23;
}

module.exports = {
    isoToDate, isoToDay, isoToTime, isSameDay, isToday, isYestoday, isMorning, isNoon, isNight
};